// Admin Dashboard Tab Types
export enum AdminTab {
  OVERVIEW = 'overview',
  SOURCES = 'sources',
  ARTICLES = 'articles',
  QUEUE = 'queue',
  COSTS = 'costs',
  MANUAL = 'manual',
  CATEGORIES = 'categories',
  ACTORS = 'actors',
  COUNTRIES = 'countries',
  PROMPTS = 'prompts',
  CACHE = 'cache',
  EMAIL = 'email'
  , SEO = 'seo'
  , ACCOUNT = 'account'
}

// Job Status Types
export enum JobStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  CANCELLED = 'CANCELLED'
}

// Source Types
export enum SourceType {
  RSS = 'RSS',
  API = 'API',
  SCRAPE = 'SCRAPE',
  GOVERNMENT = 'GOVERNMENT',
  SOCIAL = 'SOCIAL'
}

// Risk Types
export enum RiskType {
  MILITARY = 'military',
  DIPLOMATIC = 'diplomatic',
  ECONOMIC = 'economic',
  INFORMATION_WARFARE = 'informationWarfare',
  CYBER = 'cyber',
  ENERGY = 'energy'
}

// Alert Severity Types
export enum AlertSeverity {
  INFO = 'info',
  WARNING = 'warning',
  CRITICAL = 'critical'
}

// Authentication Status
export enum AuthStatus {
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
  LOADING = 'loading'
}

// Component Status
export enum ComponentStatus {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
  IDLE = 'idle'
}

// Priority Levels
export enum Priority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical'
}

// Language Codes
export enum Language {
  ENGLISH = 'en',
  ESTONIAN = 'et',
  RUSSIAN = 'ru',
  LATVIAN = 'lv',
  LITHUANIAN = 'lt'
}

// Country Codes (ISO 3166-1 alpha-3)
export enum CountryCode {
  ESTONIA = 'EST',
  LATVIA = 'LVA',
  LITHUANIA = 'LTU',
  UKRAINE = 'UKR',
  RUSSIA = 'RUS',
  BELARUS = 'BLR'
}

// AI Model Tiers
export enum AITier {
  TIER_1 = 1, // Haiku - Quick relevance
  TIER_2 = 2, // Sonnet - Detailed analysis  
  TIER_3 = 3  // Opus - Critical assessment
}

// Test Scenario Types
export enum ScenarioType {
  UKRAINE_INVASION = 'ukraine_invasion',
  CYBER_ATTACK = 'cyber_attack',
  ENERGY_CRISIS = 'energy_crisis',
  POLITICAL_TENSION = 'political_tension',
  CUSTOM = 'custom'
}

// Processing Status
export enum ProcessingStatus {
  NOT_PROCESSED = 'not_processed',
  PROCESSING = 'processing',
  PROCESSED = 'processed',
  FAILED = 'failed'
}

// Cost Alert Types
export enum CostAlertType {
  DAILY_LIMIT = 'daily_limit',
  MONTHLY_LIMIT = 'monthly_limit',
  UNUSUAL_SPIKE = 'unusual_spike',
  BUDGET_WARNING = 'budget_warning'
}

// Risk Levels
export enum RiskLevel {
  MINIMAL = 'MINIMAL',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL'
}

// Trend Directions
export enum TrendDirection {
  INCREASING = 'increasing',
  DECREASING = 'decreasing',
  STABLE = 'stable'
}
